import { Outlet, NavLink, Link, useLoaderData, Form, redirect, useNavigate, useSubmit, } from "react-router-dom";
import axios from "axios";
import { LoaderData } from "../../types/LoaderData";
import Survey from "../../interfaces/surveys";
import { Button, Card, Table, Dropdown, Badge } from 'react-daisyui'
import ViewParticipants from "./components/ViewParticipants";
import Breadcrumb from "../../components/Breadcrumb";
import dateConvert from "../../utils/dateConvert";
import { toast, ToastContainer } from 'react-toastify';

export async function loader({ params } : any) {

    const study: any = await (await axios.get(`/api/v1/study/${params.studyId}`)).data;
    let responseStatus: any;
    try{
      responseStatus = await (await axios.get(`/api/v1/study/${params.studyId}/response_status/`)).data;
    }catch(e: any){
      console.error('Error grabbing response status', e)
      responseStatus = {error: `Could not retrieve response summary. ${e.message} - '${e.response.data}'`};
    }

    study.created_at = dateConvert(study.created_at);
    study.updated_at = dateConvert(study.updated_at);
    return { study, responseStatus };
}

export default function Study() {
  const navigate = useNavigate();
  const { study, responseStatus } = useLoaderData() as LoaderData<typeof loader>;


    return (
      <>
      <div className="w-full ml-2">
        <Breadcrumb /> 
      </div>
      
      <div className="grid lg:grid-cols-4 xl:grid-cols-4  sm:grid-cols-1 custom-lg:max-custom-xl:grid-cols-3 custom-md:max-md:grid-cols-3 gap-4 w-full h-full" >
        <div className="custom-lg:max-custom-xl:col-span-1">
          <Card imageFull>
            <Card.Body>
              <Button color="primary" size="md" className="w-[80px]" id="EditStudyButton" onClick={() => navigate(`/studies/edit/${study.id}`)}>Edit</Button>
              <Card.Title tag="h2" style={{overflowWrap: 'anywhere'}} className="font-bold font-sans pt-6 pb-2 text-3xl md:text-4xl">{study.title}</Card.Title>
              
              <h3 className='text-2xl font-bold'>Info</h3>
              <div>ID: {study.id}</div>
              <div>Created: {study.created_at}</div>
              <div>Updated: {study.updated_at}</div>
              <div>Active: {study.active ?  <Badge className="ml-2" size="sm" color="success">Active</Badge> : <Badge className="ml-2" size="sm" color="info">Not active</Badge>}</div>

              <h3 className='text-2xl font-bold'>Response Summary</h3>
              { !responseStatus?.error ?
                (<div>
                  <div>Total Participants: {responseStatus.Total}</div>
                  <div>Completed Responses: {responseStatus.Completed}</div>
                  <div>Incomplete Responses: {responseStatus.Incompleted}</div>
                </div>)
                : (<div>{responseStatus.error}</div>)
              }

              {/* <div>Completed Responses: {summary.completed_responses}</div>
              <div>Full Responses: {summary.full_responses}</div>
              <div>Incomplete Responses: {summary.incomplete_responses}</div> */}
              {/* <Card.Actions className="justify-end">
                <Dropdown>
                  <Dropdown.Toggle color="primary">Actions</Dropdown.Toggle>
                  <Dropdown.Menu className="w-52">
                    <Dropdown.Item>View Participants</Dropdown.Item>
                    <Dropdown.Item>Generate Report</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Card.Actions> */}
            </Card.Body>
          </Card>

      
      </div>
      
{/* Show participants */}
 
        <div className="max-custom-xl:col-span-2 col-span-3 w-full overflow-x-auto">
          <ViewParticipants
            studyId={study.id} 
            studyTitle={study.title}
            study={study}
            disableCohortReport={study.cohort_items.length === 0 ? true : false}
            disableIndividalReport={study.individual_items.length === 0 ? true : false}
          /> 
        </div>
        <ToastContainer />
        </div>
      </>
    )

}
